import React, { ReactElement } from 'react';
import type { LucideIcon } from 'lucide-react';

/**
 * Shared icon-in-a-circle empty state for list views that have nothing to show yet
 * (e.g. a product with no sprint reports). Icon on a card-coloured disc, a bold title,
 * and an optional one-line subtitle.
 */
export const EmptyState = ({
  icon: Icon,
  title,
  subtitle,
}: {
  icon: LucideIcon;
  title: string;
  subtitle?: string;
}): ReactElement => (
  <div className="flex h-full w-full flex-col items-center justify-center gap-3 py-16">
    <div className="flex items-center justify-center rounded-full bg-card p-8">
      <Icon className="size-12 text-muted-foreground" />
    </div>
    <h2 className="text-lg font-bold text-foreground">{title}</h2>
    {subtitle && <p className="text-sm text-foreground">{subtitle}</p>}
  </div>
);
